import { Report55Component } from "../../../components/SupportSystem/Reports/Report55Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report55Container() {
    const titleName = "การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <Report55Component/>
            <Footer />
        </div>   
        // 
    )
    
}